module.exports = __webpack_public_path__ + "img/section.66b95caa.svg";